import { render, staticRenderFns } from "./newsSlider.vue?vue&type=template&id=d1f1407c&scoped=true"
import script from "./newsSlider.vue?vue&type=script&lang=js"
export * from "./newsSlider.vue?vue&type=script&lang=js"
import style0 from "./newsSlider.vue?vue&type=style&index=0&id=d1f1407c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f1407c",
  null
  
)

export default component.exports